import {useParams} from "react-router-dom";
import {useContext, useEffect, useState} from "react";
import VerificaDocumentoView from "./VerificaDocumentoView";
import axios from "axios";
import {LoaderContext} from "../../context/LoaderContext";

export default function VerificaDocumentoController() {
    const {idCertificato} = useParams()

    const [documento, setDocumento] = useState();
    const [loading, setLoading] = useState(true);

    const {startChiamata, endChiamata} = useContext(LoaderContext);

    function getDocumento() {
        startChiamata();
        axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/documento-firmato/${idCertificato}`)
            .then((response) => {
                endChiamata();
                setDocumento(response.data.data);
                setLoading(false);
            });
    }

    useEffect(() => {
        getDocumento();
    }, [idCertificato]);

    return (
        !loading &&
        <VerificaDocumentoView
            documento={documento}
        />
    );

}